export const windowsDownloadLink = "https://bit.ly/3zfWLi4";
